import HomeScreen from "./components/HomeScreen";
import Header from "./components/Header";
import Corporate from "./components/Corporates";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Footer from "./components/Footer";
import Career from "./components/Career";
import ContactUs from "./components/ContactUs";
import AboutUs from "./components/AboutUs";
import Pricing from "./components/Pricing";
import Blog from "./components/Blog";
import VerifyEmail from "./components/VerifyEmail";
import AdminDashboard from "./components/AdminDashboard";
import ChatWidget from "./components/ChatWidget";
import TrackOrder from "./components/TrackOrder";

// Header and Footer are hidden on the admin route
function Layout() {
  const { pathname } = useLocation();
  const isAdmin = pathname === "/admin";

  return (
    <>
      {!isAdmin && <Header />}

      <Routes>
        <Route path="/"           element={<HomeScreen />} />
        <Route path="/corporate"  element={<Corporate />} />
        <Route path="/about-us"   element={<AboutUs />} />
        <Route path="/careers"    element={<Career />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/pricing"    element={<Pricing />} />
        <Route path="/insights"   element={<Blog />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/track/:orderId" element={<TrackOrder />} />
        <Route path="/admin"      element={<AdminDashboard />} />
      </Routes>

      {!isAdmin && <Footer />}
      {!isAdmin && <ChatWidget />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
